/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для чекбокса фильтра
   */
  app.Filters.CheckboxView = app.BaseFilterView.extend({
    events: {
      'change': 'toggleCheck'
    },
    beforeRun: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#list-item-filter-view');
    },
    run: function (data) {
      if (data.object && data.parent) {
        if (data.object.title) {
          data.object.title = data.object.title.replace('/', '/ ');
        }
        data.parent.append(
          this.template(data)
        );
        this.setElement(data.parent.find('input:last'));
      }
    },
    
    toggleCheck: function (e) {
      this.model.set('value', this.$el.prop('checked'));
      // Фильтры по спецификациям не должны открывать попап
      if (!this.$el.hasClass('js-spec-filter')) {
        this.sendChangeEvent(e);
      }
    }
  });
})();

}.call(window));